<template>
    <span v-if="value"><currency :sign="sign" :currency="currency" :value="value"></currency></span>
</template>

<script>

    export default {

        props: {
            value: {
                type: Number,
                required: true
            },
            sign: {
                type: Boolean,
                default: false,
                required: false
            },
            currency: {
                type: String,
                required: false,
                default: '€'
            }
        }
    }
</script>
